import React from "react";
import { Box, Grid } from "@mui/material";
import CustomerCardSummaryPanel from "./components/CustomerCardSummaryPanel";
import CustomerFinancialSummaryPanel from "./components/CustomerFinancialSummaryPanel";
import CustomerPreFinanceSummaryPanel from "./components/CustomerPreFinanceSummaryPanel";
import CustomerPrimaryContactsPanel from "./components/CustomerPrimaryContactsPanel";
import CustomerSettingsSummaryPanel from "./components/CustomerSettingsSummaryPanel";
import {
  CustomerNotesChatProvider,
  CustomerNotesComposePanel,
  CustomerNotesFeedPanel,
} from "./components/CustomerNotesChatPanel";
import { usePermissions } from "../../hooks/usePermissions";
import { CAPABILITIES } from "../../auth/permissions";

const CustomerCardDashboard = ({ customerId, onOpenContactsTab }) => {
  const { hasPermission } = usePermissions();
  const canReadCardWrite = hasPermission(CAPABILITIES.customersCardWrite, "R");
  const canWriteNotes = hasPermission(CAPABILITIES.customersCardWrite, "W");
  const canReadBankAccounts = hasPermission(CAPABILITIES.bankAccountRead, "R");
  const canReadPreFinance = hasPermission(CAPABILITIES.prefinanceRead, "R");
  const canReadDocuments = hasPermission(CAPABILITIES.customersDocuments, "R");

  return (
    <CustomerNotesChatProvider customerId={customerId}>
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "minmax(0, 5fr) minmax(0, 7fr)" },
              gap: 3,
              alignItems: "stretch",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 5, minWidth: 0 }}>
              <CustomerCardSummaryPanel customerId={customerId} />
              {canReadBankAccounts ? <CustomerFinancialSummaryPanel customerId={customerId} /> : null}
              {canReadPreFinance ? <CustomerPreFinanceSummaryPanel customerId={customerId} /> : null}
              {canReadCardWrite ? (
                <CustomerPrimaryContactsPanel customerId={customerId} onOpenContactsTab={onOpenContactsTab} />
              ) : null}
            </Box>

            {canReadCardWrite ? (
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  minWidth: 0,
                  minHeight: { xs: 360, md: 0 },
                  maxHeight: { xs: "70vh", md: "none" },
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    minHeight: 0,
                    overflow: "hidden",
                    flex: 1,
                    position: { md: "absolute" },
                    inset: { md: 0 },
                  }}
                >
                  <CustomerNotesFeedPanel />
                </Box>
              </Box>
            ) : null}
          </Box>
        </Grid>

        {canReadDocuments ? (
          <Grid item xs={12} md={5}>
            <CustomerSettingsSummaryPanel customerId={customerId} />
          </Grid>
        ) : null}

        {canWriteNotes ? (
          <Grid item xs={12} md={canReadDocuments ? 7 : 12} sx={{ display: "flex", minWidth: 0 }}>
            <CustomerNotesComposePanel />
          </Grid>
        ) : null}
      </Grid>
    </CustomerNotesChatProvider>
  );
};

export default CustomerCardDashboard;
